<template>
  <div layout="column">
    <div layout="row">
      <div class="title mb-3">
        Teachers evaluations
      </div>
    </div>
    <div v-if="loaded">
      <div
        v-if="hasNoForm"
        class="alert"
      >
        <v-icon>mdi-alert-circle-outline</v-icon>
        <span>No teacher's form has been found for this type/concept of session. Please contact an administrator.</span>
      </div>
      <div v-if="isAdminEditingEval">
        <div>
          <div v-if="currentEval">
            <v-form
              ref="form"
              v-model="formValid"
              @submit.stop.prevent="save"
            >
              <div class="main-container">
                <div class="form-container">
                  <generic-form
                    :key="`${currentEval.id}-${currentEval.updated_at}`"
                    :evaluation="currentEval"
                    @change="updateRapport"
                  />
                </div>
                <div class="meta-container">
                  <div class="meta save-section mb-3">
                    <v-btn
                      depressed
                      color="primary"
                      @click="save"
                    >
                      Save form
                    </v-btn>
                    <div v-if="isAdminEditingEval">
                      <span>ou&nbsp;&nbsp;<a @click="cancelCreation">Cancel</a></span>
                    </div>
                  </div>
                </div>
              </div>
            </v-form>
          </div>
        </div>
      </div>
      <div
        v-else
        layout-gt-md="row"
        layout-align="start stretch"
        layout-wrap
        style="width: 100%"
      >
        <generic-evals
          :evaluations="evaluationsByTime"
          @edit="(e) => adminEditEval(e)"
        />
        <v-card
          ripple
          class="ml-5"
          style="background: unset; height: fit-content"
          flat
        >
          <v-card-title primary-title>
            <v-avatar
              size="80"
              style="cursor: pointer"
              @click="createEval"
            >
              <v-icon
                size="60"
                :class="{'circle-container': true, 'primary': true}"
                color="#ffffff"
              >
                mdi-plus
              </v-icon>
            </v-avatar>
          </v-card-title>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import Consts from "@/consts"
import Sessions from '@/api/sessions'
import DateMixin from '@/mixins/date'
import Auth from '@/plugins/auth'
import GenericForm from "@/components/sessions/evals/GenericForm/Form.vue"
import GenericEvals from "@/components/sessions/evals/GenericEvalsList.vue"
import FormDataMixin from '@/mixins/formdata'

export default {
  components: { GenericForm, GenericEvals },
  mixins: [DateMixin, FormDataMixin],
  props: ['session'],
  data () {
    return {
      evaluations: [],
      currentEval: null,
      user: null,
      loaded: false,
      formValid: false,
      isAdminEditingEval: false,
      Consts,
      hasNoForm: false
    }
  },
  computed: {
    evaluationsByTime() {
      return this.evaluations.toSorted((a, b) => {
        const aComp = a.updated_at ?? a.created_at
        const bComp = b.updated_at ?? b.created_at

        if(aComp < bComp) {
          return -1
        }
        else if(aComp > bComp) {
          return 1
        }
        return 0
      })
    }
  },

  mounted () {
    this.user = Auth.user.id
    this.fetch()
  },
  methods: {
    async fetch () {
      const {data: evaluations} = await Sessions.getTeacherEvals(this.$route.params.id)
      this.evaluations = evaluations
      this.currentEval = null
      this.loaded = true
    },
    updateRapport(evaluation) {
      this.currentEval = evaluation
    },
    async save() {
      if (!this.$refs.form.validate()) {
        this.$snotify.error('Please check the content of your form')
        return;
      }
      try {
        let cloneEval = structuredClone(this.currentEval)
        const {data} = await Sessions.updateTeacherEval(this.session.id, this.currentEval.id, cloneEval)
        cloneEval = null // mémoire
        this.currentEval = data
        this.isAdminEditingEval = false

        this.evaluations.splice(this.evaluations.indexOf(this.evaluations.find(e => e.id == this.currentEval.id)), 1, data)
        this.$snotify.success('The evaluation has been saved successfully')
      }
      catch(e) {
        //intercepted by axios
        console.log(e)
      }
    },
    adminEditEval(e) {
      this.isAdminEditingEval = true
      this.currentEval = e
    },
    async createEval() {
      try {
        const {data} = await Sessions.createTeacherEval(this.session.id)
        this.currentEval = data
        this.isAdminEditingEval = true
        this.evaluations.push(data)
        this.$snotify.success('Evaluation created with success')
      }
      catch(e) {
        if(e.response && e.response.status == 422) {
          this.hasNoForm = true
          this.currentEval = null
          this.isAdminEditingEval = false
        }
        this.loaded = true
      }
    },
    cancelCreation() {
      this.evalToBeCreatedForTrainerID = null
      this.isAdminEditingEval = false
    }
  }
}
</script>

<style scoped lang="sass">
  .alert
    padding: 2em
    border-radius: 9px
    border: 2px solid tomato
    color: tomato
    width: 100%
    font-size: 1.2rem
    display: flex
    flex-direction: row
    align-items: center

    i.v-icon
      font-size: 60px
      color: tomato
      margin-right: 20px

  .legend
    border-left: 5px solid tomato
    padding-left: 10px
    color: #999999
    margin-top: 10px

    &.no-border
      border-left: 5px solid #C1C1C1

    &.info-legend
      border-left: 5px solid #5dade2
      padding: 10px 0px 10px 10px
      font-size: 1.2em

  form
    width: 100%

  .main-container
    width: 100%
    display: flex
    flex-direction: row
    align-items: top
    flex-wrap: wrap-reverse

    .form-container
      flex: 1 1 500px
      min-width: 500px
      background-color: white
      padding: 24px
      border-radius: 9px

    .meta-container
      width: 400px
      margin-left: 24px
      position: relative

      .meta
        position: sticky
        top: 0px
        padding-top: 20px


      .save-section
        display: flex
        flex-direction: row
        justify-content: center
        align-items: center


  #create-as-admin
    display: flex
    align-items: center
    justify-content: flex-start
    width: 30%

</style>
